import LoginComponent from '../../components/LoginComponent';
import { PROVIDER_NAME, PROVIDER_KEY } from '../../constants';
export default function getWsbAuthProvider({
  enableIpSubscription = process.env.BLAZE_AUTH_WSB_ENABLE_IP_SUBSCRIPTION === 'true'
} = {}) {
  function getAutoLoginData({
    ctx
  }) {
    if (typeof window === 'undefined') return null;
    if (!enableIpSubscription) {
      if (!ctx || !ctx.disableSsr) return null;
      return {};
    }
    if (!ctx) return {};
    return null;
  }
  function afterAutoLogin() {
    if (!enableIpSubscription) return null;
    window.location.reload(); // reload after login
  }
  return {
    name: PROVIDER_NAME,
    key: PROVIDER_KEY,
    LoginComponent,
    getAutoLoginData,
    afterAutoLogin
  };
}
//# sourceMappingURL=get-wsb-auth-provider.js.map